import {AdditionalView} from "../comparison/additional-view";
import {InsuranceViewModel} from "../comparison/insurance-view.model";
const monthNames = ["January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"];

export class BenefitViewModel {
  userInfo: UserInfoViewModel;
  insurance: InsuranceViewModel;
  additions: AdditionalView[];

  constructor(values?: any) {
    Object.assign(this, values);
    this.userInfo = new UserInfoViewModel(values ? values.userInfo : {});
    this.insurance = new InsuranceViewModel(values ? values.insurance : {});
    if (values) {
      this.additions = values.additions ? values.additions.map(x => new AdditionalView(x)) : [];
    }
  }
}

export class UserInfoViewModel {
  companyId: number;
  firstName: string;
  lastName: string;
  companyName: string;
  modelInfo: string;
  typeOfPolicy: string;
  insuredValue: number;
  fromDate: string;
  toDate: string;
  rating: number;

  constructor(values?: any) {
    Object.assign(this, values);
  }

  public getName() {
    return `${this.firstName} ${this.lastName}`;
  }

  public getFromDate() {
    return `from ${this.fromDate}`;
  }

  public getToDate() {
    return this.toDate ? `to ${this.toDate}` : '';
  }
}
